export const LOAD_COURSES_HOME = 'LOAD_COURSES_HOME';
export const LOAD_COURSES_HOME_SUCCESS = 'LOAD_COURSES_HOME_SUCCESS';
export const LOAD_COURSES_HOME_FAIL = 'LOAD_COURSES_HOME_FAIL';
